import React, {forwardRef} from 'react';
import {Input, Icon} from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';

const DatePickerReadOnlyInput = forwardRef(({value, onClick, size, style, customClass}, ref) => {
  const inputSize = size === 'mini' ? {'fontSize': '.78571429em'} :
    size === 'big' ? {'fontSize': '1.28571429em'} :
      size === 'large' ? {'fontSize': '1.14285714em'} :
        size === 'huge' ? {'fontSize': '1.42857143em'} :
          size === 'massive' ? {'fontSize': '1.71428571em'} : {'fontSize': '1em'};
  const stylesObj = style ? Object.assign(inputSize, style) : inputSize;
  
  return <Input onClick={onClick} ref={ref} value={value}
    className={`read-only-datepicker ${customClass}`}
    style={stylesObj}
    icon={<Icon name='calendar' />} />;
});

export default DatePickerReadOnlyInput;
